// vendores
import {
  IconChevronRight,
  IconChevronLeft,
  IconUserCircle,
} from "@tabler/icons";
import {
  UnstyledButton,
  Group,
  Avatar,
  Text,
  Box,
  useMantineTheme,
  Menu,
} from "@mantine/core";

import { IconLogout } from "@tabler/icons";
import { setToken as setTokenRedux } from "../../redux/reducers/auth";
import { setUser as setUserRedux } from "../../redux/reducers/user";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// utils

export default function User() {
  const dispatch = useDispatch();
  const theme = useMantineTheme();
  const user = JSON.parse(localStorage.getItem("userInfo"));
  const navigate = useNavigate();
  const handelLogOut = () => {
    dispatch(setTokenRedux(null));
    dispatch(setUserRedux(null));
    localStorage.setItem("token", null);
    localStorage.setItem("userInfo", null);
    navigate("/", { replace: true });
  };

  return (
    <Box
      sx={{
        paddingRight: theme.spacing.xs,
      }}
    >
      <Menu width={250} withArrow>
        <Menu.Target>
          <UnstyledButton
            sx={{
              display: "block",
              width: "100%",
              padding: theme.spacing.xs,
              borderRadius: theme.radius.sm,
              color:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[0]
                  : theme.black,

              "&:hover": {
                backgroundColor:
                  theme.colorScheme === "dark"
                    ? theme.colors.dark[6]
                    : theme.colors.gray[0],
              },
            }}
          >
            <Group>
              {user?.profile_image ? (
                <Avatar
                  src={`https://api.ticketin.net/user/${user?.profile_image}`}
                  radius="xl"
                />
              ) : (
                <Avatar
                  radius="xl"
                  title={user?.username?.toUpperCase() ?? "User"}
                />
              )}
              <Box sx={{ flex: 1 }}>
                <Text size="sm" weight={500}>
                  {user?.username}
                </Text>
                <Text color="dimmed" size="xs">
                  {user?.email}
                </Text>
              </Box>

              {theme.dir === "ltr" ? (
                <IconChevronRight size={18} />
              ) : (
                <IconChevronLeft size={18} />
              )}
            </Group>

            <Menu.Dropdown>
              <Menu.Label>Settings</Menu.Label>

              <Menu.Item
                onClick={() => navigate("/app/profile")}
                icon={<IconUserCircle size={14} />}
              >
                Profile
              </Menu.Item>
              <Menu.Item
                onClick={() => handelLogOut()}
                icon={<IconLogout size={14} />}
              >
                Logout
              </Menu.Item>
            </Menu.Dropdown>
          </UnstyledButton>
        </Menu.Target>
      </Menu>
    </Box>
  );
}
